import React, { useState } from "react";
import {
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  FormControlLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import useInstructionsStyles from "../../instructionStyle/default/InstructionsStyles";
import { useLanguages } from "../../../../context/LanguagesContext";

function Popup({
  showPopup,
  setShowPopup,
  popupInstructions,
  handlePopupNext,
  setAgree,
  agree,
}) {
  const classes = useInstructionsStyles();

  const { languages, handleChange, selectedLanguage } = useLanguages();

  return (
    <Dialog 
      open={showPopup}
      onClose={() => setShowPopup(false)}
      fullWidth={true}
      maxWidth="sm"
     >
      <DialogContent className={classes.popupModal}>
        <Typography color="error" align="center" className={classes.popupNote}>
          Please Note All Questions Will Appear In Your Default Language. This
          Language Can Be Changed For A Particular Question Later On.
        </Typography>

        <div className={classes.checkboxSection} >
          <Checkbox
            checked={agree}
            onChange={() => setAgree(!agree)}
            color="primary"
            sx={{ p: 0, mr: 1, mt: 0.5 }}
          />
          <Typography 
            variant="body2" 
            sx={{ 
              fontSize: { xs: "0.75rem", sm: "0.875rem" }, 
              lineHeight: 1.4,
              cursor: 'pointer'
            }}
            onClick={() => setAgree(!agree)}
          >
            {popupInstructions}
          </Typography>
        </div>
        <div className={classes.popupActions}>
          <Select
            value={selectedLanguage}
            onChange={handleChange}
            size="small"
            className={classes.langSelect}
          >
            {languages?.map((l) => (
              <MenuItem value={l.value}>{l.label}</MenuItem>
            ))}
          </Select>
          <Button variant="contained" color="primary" onClick={handlePopupNext}>
            Next
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default Popup;
